import styled from 'styled-components'
import { lightTheme } from '@rodeo-dev/legos'

const { palette } = lightTheme
const defaultBackgroundColor = palette.primary.main
const defaultColor = palette.primary.contrastText

const TagLabel = styled.button`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || defaultBackgroundColor};
  border: 0 none;
  border-radius: 15px;
  color: ${({ color }) => color || defaultColor};
  cursor: pointer;
  font-size: 11px;
  line-height: 19px;
  max-height: 18px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100px;
  text-align: center;
  margin-right: 15px;
`

export default TagLabel
